import { Component, OnDestroy, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { HolidayState } from '../store/holiday/holiday.reducer';
import { Store } from '@ngrx/store';
import { selectHolidaysLoading, selectHolidays } from '../store/holiday/holiday.adapter';
import * as HolidayActions from '../store/holiday/holiday.actions';
import { MatDialog } from '@angular/material/dialog';
import { HolidayComponent } from './holiday/holiday.component';
import { Router } from '@angular/router';
import { Departments } from '../shared/enums/departments.enum';
import { IHoliday } from '@signal/asp-data-commons';
import { SubscriptionList } from '../shared/models/asp.types';
import { unsubscribeSubscriptions } from '../shared/services/util.service';

@Component({
  selector: 'app-dealership-holidays',
  templateUrl: './dealership-holidays.component.html',
  styleUrls: ['./dealership-holidays.component.scss']
})
export class DealershipHolidaysComponent implements OnInit, OnDestroy {

  isLoading$: Observable<boolean>;
  holidays$: Observable<IHoliday[]>;
  activeYear:number;
  currentYear:number;
  department:string;
  private subs: SubscriptionList = {};

  constructor(private readonly holidayStore: Store<HolidayState>,
    public readonly dialog: MatDialog,
    private readonly router: Router) {
    this.isLoading$ = this.holidayStore.select(selectHolidaysLoading);
    this.holidays$ = this.holidayStore.select(selectHolidays);
    this.activeYear = this.getCurrentyear();
    this.currentYear = this.activeYear;


    if(this.router.url === '/asp/sales/manageholidays'){
      this.department = Departments.SALES;
    }
    else if (this.router.url === '/asp/parts/manageholidays') {
      this.department = Departments.PARTS;
    }
    else{
      this.department =  Departments.SERVICE;
    }

    this.dispatchActions();

  }

  private dispatchActions() {
    const obj = {
      activeYear:this.activeYear.toString(),
      department:this.department,
    }
    this.holidayStore.dispatch(new HolidayActions.LoadHolidays(obj));
  }
  private loadHolidaysByYear() {
    const obj = {
      activeYear:this.activeYear.toString(),
      department:this.department,
    }
    this.holidayStore.dispatch(new HolidayActions.LoadHolidaysByYear(obj));
  }

  ngOnInit() {


  }

  get departmentTitleKey(): string {
    switch (this.department) {
      case Departments.SALES:
        return 'departmentHolidays.salesHolidays';
      case Departments.PARTS:
        return 'departmentHolidays.partsHolidays';
      default:
        return 'departmentHolidays.serviceHolidays';
    }
  }

  createHoliday(){
    const dialogRef = this.dialog.open(HolidayComponent, {
      width: '400px',
      height: 'auto',
      data:{payload:{},clicked:true},
      panelClass: 'asp-modal-container',
      disableClose:true
    });
    this.subs.dialogRef = dialogRef.componentInstance.onAdd.subscribe((result: any) =>{
      result.department = this.department;
      const obj = {
        holiday:result,
        department:this.department,
      }
      this.holidayStore.dispatch(new HolidayActions.CreateHoliday(obj));
    })
  }

  loadNextYear(){
    this.activeYear = 1 + this.getCurrentyear();
    this.loadHolidaysByYear();
  }
  loadPreviousYear(){
    this.activeYear = this.getCurrentyear();
    this.loadHolidaysByYear();
  }

  getCurrentyear(){
   return new Date().getFullYear();
  }

  ngOnDestroy() {
    unsubscribeSubscriptions(this.subs);
  }

}
